export enum Intensity {
  veryLow,
  low,
  medium,
  high,
  veryHigh,
}
